<script>
import landing_video from "@/components/landing_components/landing_video"
import welcome_to_la_citadelle from "@/components/landing_components/welcome_to_la_citadelle";
import expertises from "@/components/landing_components/expertises";
import key_indicator from "@/components/generic/key_indicator";
import centre_de_services_numeriques from "@/components/landing_components/centre_de_services_numeriques";
import offers from "@/components/landing_components/offers";
export default {
  components: {offers, centre_de_services_numeriques, welcome_to_la_citadelle, landing_video, key_indicator, expertises},
}
</script>

<template>
  <div>
    <landing_video/>
    <welcome_to_la_citadelle id="welcome"/>

    <div class="container-fluid text-center green-banner row">
      <key_indicator class="col" color="#222" icon="fas fa-building" :name="$t('landing.stats.datacenters.name')" :value="$t('landing.stats.datacenters.value')"/>
      <key_indicator class="col" color="#222" icon="fas fa-shield-alt" :name="$t('landing.stats.security_levels.name')" :value="$t('landing.stats.security_levels.value')"/>
      <key_indicator class="col" color="#222" icon="fas fa-chart-area" :name="$t('landing.stats.availability.name')" :value="$t('landing.stats.availability.value')"/>
      <key_indicator class="col" color="#222" icon="fas fa-bolt" :name="$t('landing.stats.autonomy.name')" :value="$t('landing.stats.autonomy.value')"/>
      <key_indicator class="col" color="#222" icon="fas fa-project-diagram" :name="$t('landing.stats.redundancy.name')" :value="$t('landing.stats.redundancy.value')"/>
    </div>

    <centre_de_services_numeriques/>

    <expertises/>

    <div class="container-fluid text-center green-banner row" style="padding: 1px !important;">

    </div>

    <offers/>

  </div>
</template>


<style scoped>

.green-banner {
  background: #33e091;
  padding: 40px 0;
}

.green-banner p {
  font-size: 24px;
  font-family: 'Prompt', sans-serif;
  font-weight: bold;
  color: #012f2d;
  margin-bottom: 0
}

.row {
  max-width: 100%;
  margin: 0;
}

</style>